// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown {
  margin-bottom: 3rem;
}

.status-filters {
  display: flex;
  gap: 2rem;
  margin-bottom: 3rem;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 1rem;
}

.filter-button {
  background: none;
  border: none;
  font-size: 1.6rem;
  color: #6b7280;
  padding: 0.5rem 1rem;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
}

.filter-button:hover {
  color: #2c3948;
}

.filter-button.active {
  color: #2c3948;
  font-weight: 600;
}

.filter-button.active::after {
  content: "";
  position: absolute;
  bottom: -1rem;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #f97316;
}

.count {
  background: #d90e0e;
  color: white;
  border-radius: 50%;
  padding: 0.2rem 0.6rem;
  font-size: 1.2rem;
  margin-left: 0.5rem;
  position: absolute;
  top: -0.5rem;
  right: -1rem;
}

.button-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.button-filter-group {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 60%;
}

.button-filter-group .search-bar {
  max-width: 500px;
}

.button-filter-group .search-bar input {
  padding: 9px 16px 9px 48px;
}

.button-filter-group .search-bar input::placeholder {
  font-size: 1.4rem;
}

.button-filter-group .search-bar svg {
  width: 21px;
  height: 21px;
}

.button-filter-group .button-icon {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.commandes-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.tableau-container {
  background: #fffdfc;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: visible;
  width: 100%;
}

/* Hauteur de ligne compacte — s'applique à toutes les pages utilisant TableauDeBord */
.tableau-container td {
  vertical-align: top;
  padding: 4px 6px;
  min-height: 3.6rem;
  height: 5rem !important;
}

.tableau-container td > div {
  position: relative;
  width: 100%;
}

.tableau th {
  padding: 1rem;
  background-color: #f9f9f9;
  position: relative;
  cursor: pointer;
}

/* Boutons dans les cellules : padding réduit pour ne pas gonfler les lignes */
td .button {
  padding: 0.5rem !important;
}

/* Add a wrapper for horizontal scrolling while keeping dropdown menus visible */
.tableau {
  width: 100%;
  overflow-x: auto;
}

.tableau {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 2rem;
}

.tableau tbody tr {
  transition: background-color 0.15s ease;
}

.tableau tbody tr:hover {
  background-color: #f9fafb;
}

.status-badge {
  padding: 0.5rem 1rem;
  border-radius: 12px;
  font-size: 1.4rem;
  font-weight: 500;
}

.badge-success {
  background: rgba(22, 163, 74, 0.1);
  color: #16a34a;
}

.badge-warning {
  background: rgba(217, 119, 6, 0.1);
  color: #d97706;
}

.badge-info {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
}

.badge-danger {
  background: rgba(220, 38, 38, 0.1);
  color: #dc2626;
}

.badge-pending {
  background: rgba(234, 88, 12, 0.1);
  color: #ea580c;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  align-items: center; /* Add this */
  height: 100%; /* Add this */
}

.icon-button {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-button svg {
  width: 20px;
  height: 20px;
  color: #6b7280;
}

/* ... styles existants ... */

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2rem;
}

.pagination-controls {
  display: flex;
  gap: 0.5rem;
  margin-left: auto;
}

/* Groupe droit : rassemble le slot footerLeft (ex. bouton "Telecharger le PDF") + les controles de
   pagination, cale a droite. Le bouton reste JUSTE a gauche des controles. */
.pagination-right {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-left: auto;
}
/* Dans le groupe droit, les controles ne reprennent pas leur margin-left:auto (sinon ils se
   detacheraient du bouton). */
.pagination-right .pagination-controls {
  margin-left: 0;
}
.pagination-footer-left {
  display: flex;
  align-items: center;
}

.pagination-controls button {
  padding: 0.5rem 1rem;
  border: 1px solid #e5e7eb;
  background: #fffdfc;
  border-radius: 4px;
  cursor: pointer;
  min-width: 4rem;
}

.pagination-controls button.active {
  background: #484848;
  color: #fffdfc;
  border-color: #484848;
}

.pagination-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Ajouter un style pour le survol des boutons */
.pagination-controls button:not(:disabled):hover {
  background: #f3f4f6;
}

.pagination-controls button.active:hover {
  background: #484848;
}

.tableau-wrapper {
  position: relative;
  min-height: 400px;
}

.action-bar {
  background-color: #fffdfc;
  box-shadow: 0 -2px 27px rgba(0, 0, 0, 0.1);
  padding: 1.2rem 2.4rem;
  z-index: 1000;
  width: 60%;
  border-radius: 10px;
  margin: auto;
  position: absolute;
  bottom: 30px;
  left: 245px;
}

.action-bar-content {
  max-width: 120rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.selected-count {
  font-weight: 700;
}

.action-buttons {
  display: flex;
  gap: 1.2rem;
  align-items: center;
}

.action-button {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem 1.6rem;
  border: 1px solid #d7d9d9;
  border-radius: 10px;
  background: none;
  cursor: pointer;
  color: #2c3948;
  font-weight: 700;
}

.action-button:hover {
  background-color: #f3f4f6;
}

.action-button svg {
  width: 3rem;
}

.action-button.delete {
  color: #dc2626;
}

.action-button.delete:hover {
  background-color: #fee2e2;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.8rem;
  color: #484848;
  cursor: pointer;
  padding: 0.4rem;
}

.close-button:hover {
  color: #f97316;
}

.sortable-header {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  padding-right: 2rem;
}

.sort-icon {
  position: absolute;
  right: 0.8rem;
  color: #6b7280;
  font-size: 1.2rem;
}

.sortable-header:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.sortable-header:hover .sort-icon {
  color: #2c3948;
}

.actions-buttons-container {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.action-button-direct {
  background-color: transparent;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #484848;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.action-button-direct:hover {
  background-color: #f3f4f6;
}

.action-button-direct svg {
  width: 16px;
  height: 16px;
  color: #484848;
}

.action-button-direct .option-icon {
  display: flex;
  align-items: center;
}

.action-option {
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  padding: 10px 16px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  color: #484848;
  white-space: nowrap;
}

.action-option:not(:last-child) {
  border-bottom: 1px solid #f0f0f0;
}

.action-option:last-child {
  border-bottom: none;
}

.action-option:hover {
  background-color: #f8f8f8;
}

.option-icon {
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.option-icon svg {
  width: 16px;
  height: 16px;
  color: #484848;
}

.pagination-ellipsis {
  margin: 0 0.3rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
}
`, "",{"version":3,"sources":["webpack://./src/composants/TableauDeBord/TableauDeBord.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA,sFAAsF;AACtF;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,8EAA8E;AAC9E;EACE,0BAA0B;AAC5B;;AAEA,gFAAgF;AAChF;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,mBAAmB,EAAE,aAAa;EAClC,YAAY,EAAE,aAAa;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,6BAA6B;;AAE7B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;6EAC6E;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;AACA;8BAC8B;AAC9B;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,sBAAsB;EACtB,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":[".dropdown {\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n.status-filters {\r\n  display: flex;\r\n  gap: 2rem;\r\n  margin-bottom: 3rem;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  padding-bottom: 1rem;\r\n}\r\n\r\n.filter-button {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.6rem;\r\n  color: #6b7280;\r\n  padding: 0.5rem 1rem;\r\n  cursor: pointer;\r\n  position: relative;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.filter-button:hover {\r\n  color: #2c3948;\r\n}\r\n\r\n.filter-button.active {\r\n  color: #2c3948;\r\n  font-weight: 600;\r\n}\r\n\r\n.filter-button.active::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: -1rem;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 2px;\r\n  background-color: #f97316;\r\n}\r\n\r\n.count {\r\n  background: #d90e0e;\r\n  color: white;\r\n  border-radius: 50%;\r\n  padding: 0.2rem 0.6rem;\r\n  font-size: 1.2rem;\r\n  margin-left: 0.5rem;\r\n  position: absolute;\r\n  top: -0.5rem;\r\n  right: -1rem;\r\n}\r\n\r\n.button-group {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.button-filter-group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  width: 60%;\r\n}\r\n\r\n.button-filter-group .search-bar {\r\n  max-width: 500px;\r\n}\r\n\r\n.button-filter-group .search-bar input {\r\n  padding: 9px 16px 9px 48px;\r\n}\r\n\r\n.button-filter-group .search-bar input::placeholder {\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.button-filter-group .search-bar svg {\r\n  width: 21px;\r\n  height: 21px;\r\n}\r\n\r\n.button-filter-group .button-icon {\r\n  width: 18px;\r\n  height: 18px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.commandes-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.tableau-container {\r\n  background: #fffdfc;\r\n  border-radius: 8px;\r\n  padding: 1rem;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  position: relative;\r\n  overflow: visible;\r\n  width: 100%;\r\n}\r\n\r\n/* Hauteur de ligne compacte — s'applique à toutes les pages utilisant TableauDeBord */\r\n.tableau-container td {\r\n  vertical-align: top;\r\n  padding: 4px 6px;\r\n  min-height: 3.6rem;\r\n  height: 5rem !important;\r\n}\r\n\r\n.tableau-container td > div {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.tableau th {\r\n  padding: 1rem;\r\n  background-color: #f9f9f9;\r\n  position: relative;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Boutons dans les cellules : padding réduit pour ne pas gonfler les lignes */\r\ntd .button {\r\n  padding: 0.5rem !important;\r\n}\r\n\r\n/* Add a wrapper for horizontal scrolling while keeping dropdown menus visible */\r\n.tableau {\r\n  width: 100%;\r\n  overflow-x: auto;\r\n}\r\n\r\n.tableau {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.tableau tbody tr {\r\n  transition: background-color 0.15s ease;\r\n}\r\n\r\n.tableau tbody tr:hover {\r\n  background-color: #f9fafb;\r\n}\r\n\r\n.status-badge {\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 12px;\r\n  font-size: 1.4rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.badge-success {\r\n  background: rgba(22, 163, 74, 0.1);\r\n  color: #16a34a;\r\n}\r\n\r\n.badge-warning {\r\n  background: rgba(217, 119, 6, 0.1);\r\n  color: #d97706;\r\n}\r\n\r\n.badge-info {\r\n  background: rgba(59, 130, 246, 0.1);\r\n  color: #3b82f6;\r\n}\r\n\r\n.badge-danger {\r\n  background: rgba(220, 38, 38, 0.1);\r\n  color: #dc2626;\r\n}\r\n\r\n.badge-pending {\r\n  background: rgba(234, 88, 12, 0.1);\r\n  color: #ea580c;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 1rem;\r\n  margin-top: 2rem;\r\n  align-items: center; /* Add this */\r\n  height: 100%; /* Add this */\r\n}\r\n\r\n.icon-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.icon-button svg {\r\n  width: 20px;\r\n  height: 20px;\r\n  color: #6b7280;\r\n}\r\n\r\n/* ... styles existants ... */\r\n\r\n.pagination {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-top: 2rem;\r\n}\r\n\r\n.pagination-controls {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  margin-left: auto;\r\n}\r\n\r\n/* Groupe droit : rassemble le slot footerLeft (ex. bouton \"Telecharger le PDF\") + les controles de\r\n   pagination, cale a droite. Le bouton reste JUSTE a gauche des controles. */\r\n.pagination-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  margin-left: auto;\r\n}\r\n/* Dans le groupe droit, les controles ne reprennent pas leur margin-left:auto (sinon ils se\r\n   detacheraient du bouton). */\r\n.pagination-right .pagination-controls {\r\n  margin-left: 0;\r\n}\r\n.pagination-footer-left {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.pagination-controls button {\r\n  padding: 0.5rem 1rem;\r\n  border: 1px solid #e5e7eb;\r\n  background: #fffdfc;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  min-width: 4rem;\r\n}\r\n\r\n.pagination-controls button.active {\r\n  background: #484848;\r\n  color: #fffdfc;\r\n  border-color: #484848;\r\n}\r\n\r\n.pagination-controls button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Ajouter un style pour le survol des boutons */\r\n.pagination-controls button:not(:disabled):hover {\r\n  background: #f3f4f6;\r\n}\r\n\r\n.pagination-controls button.active:hover {\r\n  background: #484848;\r\n}\r\n\r\n.tableau-wrapper {\r\n  position: relative;\r\n  min-height: 400px;\r\n}\r\n\r\n.action-bar {\r\n  background-color: #fffdfc;\r\n  box-shadow: 0 -2px 27px rgba(0, 0, 0, 0.1);\r\n  padding: 1.2rem 2.4rem;\r\n  z-index: 1000;\r\n  width: 60%;\r\n  border-radius: 10px;\r\n  margin: auto;\r\n  position: absolute;\r\n  bottom: 30px;\r\n  left: 245px;\r\n}\r\n\r\n.action-bar-content {\r\n  max-width: 120rem;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.selected-count {\r\n  font-weight: 700;\r\n}\r\n\r\n.action-buttons {\r\n  display: flex;\r\n  gap: 1.2rem;\r\n  align-items: center;\r\n}\r\n\r\n.action-button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.8rem;\r\n  padding: 0.8rem 1.6rem;\r\n  border: 1px solid #d7d9d9;\r\n  border-radius: 10px;\r\n  background: none;\r\n  cursor: pointer;\r\n  color: #2c3948;\r\n  font-weight: 700;\r\n}\r\n\r\n.action-button:hover {\r\n  background-color: #f3f4f6;\r\n}\r\n\r\n.action-button svg {\r\n  width: 3rem;\r\n}\r\n\r\n.action-button.delete {\r\n  color: #dc2626;\r\n}\r\n\r\n.action-button.delete:hover {\r\n  background-color: #fee2e2;\r\n}\r\n\r\n.close-button {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.8rem;\r\n  color: #484848;\r\n  cursor: pointer;\r\n  padding: 0.4rem;\r\n}\r\n\r\n.close-button:hover {\r\n  color: #f97316;\r\n}\r\n\r\n.sortable-header {\r\n  cursor: pointer;\r\n  user-select: none;\r\n  position: relative;\r\n  padding-right: 2rem;\r\n}\r\n\r\n.sort-icon {\r\n  position: absolute;\r\n  right: 0.8rem;\r\n  color: #6b7280;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.sortable-header:hover {\r\n  background-color: rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.sortable-header:hover .sort-icon {\r\n  color: #2c3948;\r\n}\r\n\r\n.actions-buttons-container {\r\n  display: flex;\r\n  gap: 8px;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.action-button-direct {\r\n  background-color: transparent;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 4px;\r\n  padding: 5px 10px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-size: 12px;\r\n  color: #484848;\r\n  white-space: nowrap;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.action-button-direct:hover {\r\n  background-color: #f3f4f6;\r\n}\r\n\r\n.action-button-direct svg {\r\n  width: 16px;\r\n  height: 16px;\r\n  color: #484848;\r\n}\r\n\r\n.action-button-direct .option-icon {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.action-option {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  text-align: left;\r\n  padding: 10px 16px;\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  color: #484848;\r\n  white-space: nowrap;\r\n}\r\n\r\n.action-option:not(:last-child) {\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.action-option:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.action-option:hover {\r\n  background-color: #f8f8f8;\r\n}\r\n\r\n.option-icon {\r\n  margin-right: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.option-icon svg {\r\n  width: 16px;\r\n  height: 16px;\r\n  color: #484848;\r\n}\r\n\r\n.pagination-ellipsis {\r\n  margin: 0 0.3rem;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #6b7280;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
